import type { MutableRefObject, Ref } from 'react';
import { useMemo } from 'react';

export function mergeRefs<TElement extends HTMLElement>(
    ...refs: (Ref<TElement | null> | null | undefined)[]
) {
    return (node: TElement | null) => {
        refs.forEach((ref) => {
            if (typeof ref === 'function') {
                ref(node);
            } else if (ref !== null && ref !== undefined) {
                (ref as MutableRefObject<TElement | null>).current = node;
            }
        });
    };
}

export function useMergedRefs<TElement extends HTMLElement>(
    ...refs: (Ref<TElement | null> | null | undefined)[]
) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => mergeRefs(...refs), refs);
}
